import React from "react";
import TextField from "../Reusable/TextField";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import ComboboxInput from "../Reusable/ComboboxInput";
import APIS from "../../constant/EndPoint";
import MultipleSelectField from "../Reusable/MultiSelectField";

const CountryForm = ({
  register,
  errors,
  setValue,
  getValues,
  clearErrors,
  watch,
}: any) => {
  return (
    <>
      <div className={tw`grid grid-cols-1 md:grid-cols-2 gap-x-4 mx-4`}>
        <TextField
          label={"Name"}
          register={register("name")}
          errors={errors?.name}
        />
        <MultipleSelectField
          errors={errors?.group}
          label={"Group"}
          queryKey={"group-list"}
          register={register("group")}
          setValue={setValue}
          watch={watch}
          props={{
            group: true,
          }}
          url={APIS.LOCATION}
          getValues={getValues}
          clearErrors={clearErrors}
          name={"group"}
          value={getValues("group")}
        />
        <TextField
          label={"Code"}
          register={register("code")}
          errors={errors?.code}
        />
      </div>
    </>
  );
};

export default CountryForm;
